import React from 'react';
import './VisionMission.css';
import { FaEye, FaBullseye, FaHandsHelping, FaHeart, FaUsers, FlGraduationCap, FaGraduationCap, FaLightbulb } from 'react-icons/fa';
import MyFooter from './MyFooter';
import { useLanguage } from '../context/LanguageContext';

const VisionMission = () => {
  const { language } = useLanguage();

  return (
    <div className="vm-container">
      {/* Banner Section */}
      <div className="vm-banner">
        <img 
          src="/vm-banner.jpg" 
          alt="Our Vision and Mission" 
          className="banner-img"
        />
        <div className="banner-overlay">
          <h1>Our Guiding Principles</h1>
          <p>Compassionate care at the heart of everything we do</p>
        </div>
      </div>

      {/* Vision Section */}
      <section className="vision-section">
        <div className="section-header">
          <FaEye className="section-icon vision-icon" />
          <h2>Our Vision{language === 'ml' ? ' - ഞങ്ങളുടെ ദൃശ്യം' : 'About Us'}</h2>
        </div>
        <div className="content-box">
          <img 
            src="/vimage.png" 
            alt="Vision illustration" 
            className="content-image"
          />
          <div className="text-content">
            <p className="vision-text">
              To ensure every individual has access to high-quality, compassionate palliative care through a sustainable, 
              community-led model supported by education and research.
            </p>
            <div className="vision-points">
              <div className="point">
                <FaHeart className="point-icon" />
                <span>Compassionate Care</span>
              </div>
              <div className="point">
                <FaUsers className="point-icon" />
                <span>Community-Led Model</span>
              </div>
              <div className="point">
                <FaGraduationCap className="point-icon" />
                <span>Education & Research</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="section-header">
          <FaBullseye className="section-icon mission-icon" />
          <h2>Our Mission</h2>
        </div>
        <div className="content-box reverse">
          <img 
            src="/mimage.jpg" 
            alt="Mission illustration" 
            className="content-image"
          />
          <div className="text-content">
            <p className="mission-text">
              Delivering dignified, innovative, and comprehensive palliative care to the community through a decentralised, 
              volunteer-driven model.
            </p>
            <div className="mission-points">
              <div className="point">
                <FaHandsHelping className="point-icon" />
                <span>Dignified Care</span>
              </div>
              <div className="point">
                <FaLightbulb className="point-icon" />
                <span>Innovative Solutions</span>
              </div>
              <div className="point">
                <FaUsers className="point-icon" />
                <span>Volunteer-Driven</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <MyFooter/>
    </div>
  );
};

export default VisionMission;